// extracted by mini-css-extract-plugin
export default {"cartContainer":"CarrinhoIcon_cartContainer__dJc8b","carrinhoIcon":"CarrinhoIcon_carrinhoIcon__F5A0P","cartIcon":"CarrinhoIcon_cartIcon__O-VLK","badge":"CarrinhoIcon_badge__MysLU"};